<div class="flexbox-row justify-content-md-end justify-content-start">
  @if(!loadHistoryGrid()){
  <div class="flexbox-row">
    @if (selection.hasValue()) {
    <p class="title text-gray-9">Selected '{{ selection?.selected?.length ?? 0 }} Files'</p>
    }
    <button mat-button mat-flat-button color="primary" class="button-default" [disabled]="!selection.selected.length"
      (click)="openDeleteHistory()">
      Delete History
    </button>
  </div>
}

</div>

<div class="card table-responsive flex-1 mt-1" *ngIf="historyData.length">
  <table mat-table [dataSource]="dataSource" matSort #parentSort="matSort" multiTemplateDataRows
    class="table-countable">

    <!-- Select Column-->
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)" [disabled]="!(['Completed', 'Failed'].includes(row.exportStatus))">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="{{column}}" *ngFor="let column of nonActionableColumns">
      <th mat-header-cell *matHeaderCellDef mat-sort-header
        [ngClass]="{'eng-count': column === 'engagementCount','client-count': column === 'clientCount'}"
        [disabled]="['clientCount', 'engagementCount'].includes(column)"> {{columnDefs[column]}}
        <button *ngIf="['exportedByName','exportStatus'].includes(column)" mat-icon-button [matMenuTriggerFor]="menu"
          #assignSortTrigger="matMenuTrigger" (click)="$event.stopPropagation()">
          <i class="fa-solid fa-bars-filter fs-15"></i>
        </button>
        <mat-menu #menu="matMenu" #beforeMenu="matMenu" xPosition="before" class="mt-1">
          <div class="button-group justify-content-end p-2 border-bottom">
            <button mat-button class="button-text fs-12" (click)="clearFilter(column);$event.stopPropagation();">Clear
              All</button>
          </div>
          <div class="mat-list-item d-block overflow-auto">
            <ng-container *ngFor="let col of columnFilterData[column];">
              <button mat-menu-item>
                <mat-checkbox [checked]="col.isChecked" (change)='onFilterChanged(column, col, $event.checked)'
                  (click)="$event.stopPropagation()">
                  {{ col.value ? col.value : '(Blank)'}}
                </mat-checkbox>
              </button>
            </ng-container>
          </div>
        </mat-menu>
      </th>
      <td mat-cell *matCellDef="let row"
        [ngClass]="{'eng-count': column === 'engagementCount','client-count': column === 'clientCount'}">
        <ng-container *ngIf="column === 'exportStatus'; else nonStatus">
          <div class="ft-cell d-flex align-items-center justify-content-start status">
            <p class="badge badge-pills badge-medium badge-{{row[column]}}">
              {{row[column]}} </p>
          </div>
        </ng-container>
        <ng-template #nonStatus>
          <span>{{ row[column] }}</span>
        </ng-template>
      </td>
    </ng-container>

    <!-- view details Column -->
    <ng-container matColumnDef="viewDetails">
      <th mat-header-cell *matHeaderCellDef class="text-center">Details</th>
      <td mat-cell *matCellDef="let row">
        <span class="d-flex justify-content-center">
          <button class="border-0 transparent-btn d-flex align-items-center" style="color: #004B92;"
            (click)="expandedElement = expandedElement === row ? null : row; expandedElement ? getRowDetails(row) : '';"
            [disabled]="['In progress', 'Failed', 'Not Started'].includes(row.exportStatus)">
            <span class="text-primary"
              [ngClass]="{'text-gray-9':  ['In progress', 'Failed', 'Not Started'].includes(row.exportStatus)}"
              [ngStyle]="{'opacity': ['In progress', 'Failed', 'Not Started'].includes(row.exportStatus)  ? '0.5' : ' 1'}"></span>
            <span>View Details</span>
            <i class="fa-regular" [ngClass]="(expandedElement === row ? 'fa-chevron-up' : 'fa-chevron-down')"></i>

          </button>
        </span>

      </td>
    </ng-container>

    <!-- action Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="border-start text-center">Actions</th>
      <td mat-cell *matCellDef="let row" class="p-0 border-start text-center">
          <button class="pl-0" mat-icon-button (click)="downloadHistory(row?.hash)"
                  [ngClass]="{'disabled': exportRowIds()?.includes(row?.hash)}"
          [ngStyle]="{'opacity': ['In progress', 'Failed', 'Not Started'].includes(row.exportStatus)  ? '0.5' : ' 1'}"
                  [disabled]="['In progress', 'Failed', 'Not Started'].includes(row.exportStatus) || (exportRowIds()?.includes(row?.hash))">
                  <i class="fa-regular fa-cloud-arrow-down text-primary-darker"></i>
        </button>
        <button mat-icon-button class="delete-button" (click)="openDeleteFile(row)"
          [ngStyle]="{'opacity': !(['Completed', 'Failed'].includes(row.exportStatus))  ? '0.5' : ' 1'}"
          [disabled]="!(['Completed', 'Failed'].includes(row.exportStatus))">
          <i class="fa-regular fa-trash-can"></i>
        </button>
      </td>
    </ng-container>

    <!--Expanded -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="p-0">
        <div class="w-100 overflow-hidden" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
          <div class="m-4 d-flex flex-row gap-20 w-500 card table-responsive flex-1">
            <table mat-table [dataSource]="detailDataSource" matSort (matSortChange)="customSort($event)"
              class="table-countable">

              <!-- All Columns -->
              <ng-container matColumnDef="{{column}}" *ngFor="let column of viewDetailColumns">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{detailsColumnDefs[column]}}
                </th>
                <td mat-cell *matCellDef="let row">
                  <ng-container *ngIf="column === 'downloadedBY';else other">
                    {{row.initials}} {{row[column]}}
                  </ng-container>
                  <ng-template #other>
                    {{row[column]}}
                  </ng-template>
                </td>
              </ng-container>

              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="viewDetailColumns.length">
                  @if(!loadDetailGrid()){
                    No data found.
                  }
                </td>
              </tr>

              <tr mat-header-row *matHeaderRowDef="viewDetailColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: viewDetailColumns;"></tr>
            </table>
          </div>
        </div>
      </td>
    </ng-container>

    <tr class="mat-row" *matNoDataRow>
      @if(!loadHistoryGrid()){      
        No data found.
      }
    </tr>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="example-element-row"
      [class.example-expanded-row]="expandedElement === row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
  </table>
</div>

<!--Export History-->
<ng-template #deleteHistoryPopup>
  <div class="countable-dialog confirmation-dailog">
    <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
      <span class="badge badge-error badge-circle icon-bordered-error text-center">
        <i class="fa-regular fa-circle-info"></i>
      </span>
      <h4 class="title text-center">Delete Selected History</h4>
      <button color="error" class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>
    <div mat-dialog-content class="content dialog-body-content text-center pt-1">
      <p>
        Are you sure you want to delete the history?
      </p>
    </div>
    <div mat-dialog-actions class="dialog-footer button-group">
      <button mat-button mat-stroked-button color="dark" class="button-default" [mat-dialog-close]>Cancel</button>
      <button mat-button mat-flat-button color="error" class="button-default" [mat-dialog-close]
        (click)="deleteHistory()">
        Delete
      </button>
    </div>
  </div>
</ng-template>

<!--Delete File-->
<ng-template #deleteFilePopup>
  <div class="countable-dialog confirmation-dailog">
    <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
      <span class="badge badge-error badge-circle icon-bordered-error text-center">
        <i class="fa-regular fa-circle-info"></i>
      </span>
      <h4 class="title text-center">Delete File</h4>
      <button color="error" class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>
    <div mat-dialog-content class="content dialog-body-content text-center pt-1">
      <p>
        Are you sure you want to delete the file?
      </p>
    </div>
    <div mat-dialog-actions class="dialog-footer button-group">
      <button mat-button mat-stroked-button color="dark" class="button-default" [mat-dialog-close]>No</button>
      <button mat-button mat-flat-button color="error" class="button-default" [mat-dialog-close]
        (click)="deleteHistory()">
        Yes
      </button>
    </div>
  </div>
</ng-template>

<ng-template #exportDownloadFailed>
  <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
    <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
      <span class="badge badge-error badge-circle icon-bordered-error text-center">
        <i class="fa-regular fa-circle-info"></i>
      </span>
      <h4 class="title text-center">Download Failed</h4>
      <button color="error" class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>
    <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
      <p>The file you are trying to download failed</p>
    </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]="false">Cancel
      </button>
      <button mat-button mat-flat-button class="button-default" color="error" [mat-dialog-close]="true">Retry
      </button>
    </div>
  </div>
</ng-template>

@if(exportStarted()){
  <div class="countable-dialog confirmation-dailog export-zip">
    <div class="toast-container toast-top-right flexbox-row export-action-toaster">
      <div class="ngx-toastr icon-none flex-row w-100 h-100">
        <span class="badge badge-warning badge-circle icon-bordered-primary text-center align-self-start">
            <i class="fa-regular fa-cloud-arrow-down"></i>
        </span>
        <div class="toast-message d-flex flex-column flex-wrap gap-6 flex-1">
          <h5 class="fw-medium">Exporting 'File.zip'</h5>
          <button mat-button class="close" (click)="exportStarted.set(false)">
            <i class="fa-regular fa-xmark clear-icon"></i>
          </button>
          <p> Please wait while we export your file.</p>
          <p>You can view the file status from Export History. </p>
        </div>
      </div>
    </div>
  </div>
}


@if (exportCompleted()) {
<div class="countable-dialog confirmation-dailog export-zip">
  <div class="toast-container toast-top-right mb-3">
    <div class="ngx-toastr toast-success w-100">
      <div class="toast-message d-flex flex-wrap">
        <button mat-button mat-button-base class="mat-focus-indicator close mat-button mat-button-base"
          (click)="exportCompleted.set(false);$event.stopPropagation()">
          <i class="fa-regular fa-xmark clear-icon"></i>
          <span matripple="" class="mat-ripple mat-button-ripple"></span>
          <span class="mat-button-focus-overlay"></span>
        </button>
        <div class="d-flex gap-4 flex-column">
          <h6 class="title">Successfully exported file</h6>
          <p class="information">You can download the file from Export History
          </p>
        </div>

      </div>
    </div>
  </div>
</div>
}
